import styled, { keyframes } from 'styled-components';
import {
	statusInfoIcon, statusWarningIcon, statusErrorIcon, statusSuccessIcon,
	blue25, orange25, red50, green25, grayBodyText,
} from '../themes/colors';
/* eslint-disable max-len */

const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(-50px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const fadeOut = keyframes`
	from {
		opacity: 1;
		transform: translateY(0);
	}
	to {
		opacity: 0;
		transform: translateY(-20px);
	}
`;

// Add color mapping for variants
const getVariantColor = ($variant: 'info' | 'warning' | 'danger' | 'success') => {
	switch ($variant) {
	case 'info':
		return statusInfoIcon;
	case 'warning':
		return statusWarningIcon;
	case 'danger':
		return statusErrorIcon;
	case 'success':
		return statusSuccessIcon;
	default:
		return statusInfoIcon;
	}
};

export const IconWrapper = styled.div<{ $variant: 'info' | 'warning' | 'danger' | 'success' }>`
	color: ${({ $variant }) => getVariantColor($variant)};
	display: flex;
	align-items: center;
	justify-content: center;

	.icon {
		font-size: 20px;
		margin-bottom: 2px;
	}

	svg {
		fill: currentColor;
	}
`;

export const CloseButton = styled.button<{ $variant: 'info' | 'warning' | 'danger' | 'success' }>`
	background: none;
	border: none;
	cursor: pointer;
	padding: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: opacity 0.2s ease;
	color: ${({ $variant }) => getVariantColor($variant)};

	.icon {
		font-size: 20px;
		margin-bottom: 2px;
	}

	svg {
		fill: currentColor;
	}

	&:hover {
		opacity: 1;
	}
`;

export const SimpleToastWrapper = styled.div<{ 
	$variant: 'info' | 'warning' | 'danger' | 'success';
	$isExiting?: boolean;
}>`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	position: relative;
	background-color: ${({ $variant }) =>
		$variant === 'info' ? blue25 :
			$variant === 'warning' ? orange25 :
				$variant === 'danger' ? red50 :
					green25};
	position: absolute;
	top: 100px;
	right: calc(50% - 231px);
	padding: 12px 20px;
	border-radius: 30px;
	max-width: 462px;
	width: 100%;
	box-shadow: 0px 4px 30px 6px rgba(32, 56, 87, 0.4);
	animation: ${({ $isExiting }) => $isExiting ? fadeOut : fadeIn} 0.2s ease-in-out forwards;
	align-items: center;
`; 

export const SimpleToastContentWrap = styled.span`
	font-size: 14px;
	font-weight: 600;
	font-family: "Red Hat Display", sans-serif;
	margin: 0;
	color: ${grayBodyText};
`;

export const SimpleToastText = styled.span`  
	font-size: 16px;
	font-weight: 400;
	font-family: "Red Hat Display", sans-serif;
`;

export const SimpleToastContent = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
`;
